export function randomItem(array) {
  return array[Math.floor(Math.random() * array.length)];
}

export function objectToFormData(object) {
  const form = new FormData();

  Object.keys(object).forEach((key) => {
    if (Array.isArray(object[key])) {
      object[key].forEach((value) => {
        form.append(`${key}[]`, value);
      });
    } else {
      form.append(key, object[key]);
    }
  });

  return form;
}

export function convertToUnit(value, unit = 'px') {
  if (value == null || value === '') {
    return undefined;
  }

  if (Number.isNaN(+value)) {
    return String(value);
  }

  return `${Number.parseInt(value, 10)}${unit}`;
}

export function tap(value, callback) {
  callback(value);

  return value;
}

export function readableSeconds(seconds) {
  const date = new Date(null);
  date.setSeconds(seconds);

  if (Math.floor(seconds / 3600) > 0) {
    return date.toISOString().substr(11, 8);
  }

  return date.toISOString().substr(14, 5);
}

/**
 * @returns {boolean}
 */
export function isInFullScreenMode() {
  const element = document.fullscreenElement
    || document.webkitFullscreenElement
    || document.mozFullScreenElement
    || document.msFullscreenElement;

  return element !== null && element !== undefined;
}

/**
 * @param {HTMLElement} el
 * @returns {Promise<void>|*}
 */
export function requestFullScreen(el) {
  if (el.requestFullscreen) {
    return el.requestFullscreen();
  }

  if (el.webkitRequestFullscreen) {
    return el.webkitRequestFullscreen();
  }

  if (el.mozRequestFullScreen) {
    return el.mozRequestFullScreen();
  }

  if (el.msRequestFullscreen) {
    return el.msRequestFullscreen();
  }

  if (el.oRequestFullscreen) {
    return el.oRequestFullscreen();
  }

  return null;
}

export function exitFullScreen() {
  if (document.exitFullscreen) {
    return document.exitFullscreen();
  }

  if (document.webkitExitFullscreen) {
    return document.webkitExitFullscreen();
  }

  if (document.mozCancelFullScreen) {
    return document.mozCancelFullScreen();
  }

  if (document.msExitFullscreen) {
    return document.msExitFullscreen();
  }

  return null;
}

const userAgentMatch = (ua) => navigator.userAgent.match(new RegExp(ua, 'gi'));

export function isShitBrowser() {
  const shitBrowsers = ['MiuiBrowser', 'Miui', 'Opera Mini', ['OPR', 'Mobile'], ['Opera', 'Mobile'],
    'Duck', ['YaBrowser', 'Mobile'], 'Ecosia', 'Brave', 'Lilo', 'Edge', 'Mint', 'Vivaldi',
    'Qwant', 'Maxthon', 'Kiwi', 'Atom', 'Instagram',
    ['Mozilla', 'Mobile', 'Firefox'], ['Mozilla', 'Mobile', 'FxiOS'], ['OPT', 'Mobile'],
    'Vivo', 'UCBrowser', 'Puffin', 'Samsung Browser', 'SamsungBrowser', 'Samsung Internet'];
  const allowedBrowsers = ['Chrome', 'Opera', 'Mozilla', 'Firefox'];

  function checkBrowsers(ua) {
    if (Array.isArray(ua)) {
      return ua.reduce((acc, item) => userAgentMatch(item) && acc, true);
    }
    return userAgentMatch(ua);
  }

  return !navigator.userAgent
    || (shitBrowsers.some(checkBrowsers) || !allowedBrowsers.some(checkBrowsers)
    );
}

export function isSafari() {
  return !!navigator.userAgent
    && /Safari/i.test(navigator.userAgent)
    && !/Chrome/i.test(navigator.userAgent);
}

export function isIOS() {
  return !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
}

export function canRecordInterview() {
  return (!!navigator.mediaDevices
    && !!navigator.mediaDevices.getUserMedia
    && !!navigator.mediaDevices.enumerateDevices
    && !!window.MediaRecorder && !isShitBrowser() && !isIOS());
}

export function pushDebugLog(scope, message, payload) {
  const entry = {
    time: new Date().toISOString(),
    scope,
    message,
    payload,
  };

  if (typeof window !== 'undefined') {
    if (!Array.isArray(window.__VIDEO_CALLS_DEBUG__)) {
      window.__VIDEO_CALLS_DEBUG__ = [];
    }

    window.__VIDEO_CALLS_DEBUG__.push(entry);
  }

  if (typeof payload === 'undefined') {
    console.log(`[${scope}] ${message}`);
  } else {
    console.log(`[${scope}] ${message}`, payload);
  }

  return entry;
}

export function isNeedHls() {
  return isIOS() || !MediaSource;
}

export function isAndroid() {
  return !!navigator.userAgent
    && /Android|Mobile/i.test(navigator.userAgent);
}
